import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import trackAnalyticsEvent from "../../lib/trackAnalyticsEvent";
import BusinessPage from "./BusinessPage";
import Label from "../../components/Label";
import Card from "../../components/Card";
import Button from "../../components/buttons/Button";
import useSignOut from "../../lib/hooks/useSignOut";
import { getPreviousRelativeUrlFromLocation } from "../../lib/query/location";
import { skipBlockAccountSessionStorageKey } from "../../lib/constants";
import { useHypertune } from "../../generated/hypertune.react";

export default function SharedAccountPage(): React.ReactElement {
  useEffect(() => {
    document.title = "Hypertune";
    trackAnalyticsEvent("shared_account_page_view");
  }, []);

  const signOut = useSignOut();

  const location = useLocation();

  const previousRelativeUrl =
    getPreviousRelativeUrlFromLocation(location) ?? "/";

  const navigate = useNavigate();

  const hypertune = useHypertune();

  const blockSharedAccounts = hypertune
    .features()
    .blockSharedAccounts({ fallback: "noBlock" });

  return (
    <BusinessPage>
      <Label type="title1" className="mb-5">
        Shared account
      </Label>
      <Card layout="horizontal">
        <div className="flex flex-col gap-[12px]">
          <p className="text-tx-muted">
            It looks like you're using a shared account, which is against our
            terms of service due to security, audit, compliance, and support
            reasons. Please transition to an individual account. Feel free to
            reach out over the live chat if you need any help or have any
            questions. If pricing is a concern, we may be able to help.
          </p>
          <Button
            text="Sign out"
            onClick={signOut}
            intent="primary"
            weight="outlined"
          />
          {blockSharedAccounts === "softBlock" && (
            <Button
              text="Continue"
              onClick={async () => {
                sessionStorage.setItem(skipBlockAccountSessionStorageKey, "1");
                await navigate(previousRelativeUrl);
              }}
              intent="primary"
              weight="outlined"
            />
          )}
        </div>
      </Card>
    </BusinessPage>
  );
}
